module.exports = __webpack_public_path__ + "static/media/layout6-vid.e2c3b0da.svg";